/**
 * 获取某个月周一的数量
 * @param year 年份
 * @param month 月份
 * @param startTime
 * @param endTime
 * @returns {number} 数量
 */

const mondays = (year, month) => {
    let day, counter, date;
    day = 1;
    counter = 0;
    date = new Date(year, month, day);
    while (date.getMonth() === month) {
        if (date.getDay() === 1) { // Sun=0, Mon=1, Tue=2, etc.
            counter += 1;
        }
        day += 1;
        date = new Date(year, month, day);
    }
    return counter;
};

export {mondays};